import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import { LanguageProvider } from './i18n/LanguageContext';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
	components: {
	  MuiCssBaseline: {
		styleOverrides: {
		  // Глобально для всіх Box
		  '.MuiBox-root': {
			fontSize: '16px',
		  },
		},
	  },
	  MuiTypography: {
		styleOverrides: {
		  root: ({ ownerState }) => ({
			color: '#595959',
			fontSize: !['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(ownerState.variant)
			  ? '16px'
			  : undefined,
		  }),
		},
	  },
	  MuiInputBase: {
		styleOverrides: {
		  root: {
			fontSize: '16px',
		  },
		  input: {
			fontSize: '16px',
		  },
		},
	  },
	  MuiTextField: {
		styleOverrides: {
		  root: {
			'& label.Mui-focused': {
			  color: '#0086c8',
			},
			'& .MuiInput-underline:after': {
			  borderBottomColor: '#0086c8',
			},
			'& .MuiOutlinedInput-root': {
			  '&:hover fieldset': {
				borderColor: '#0086c8',
			  },
			  '&.Mui-focused fieldset': {
				borderColor: '#0086c8',
			  },
			},
		  },
		},
	  },
	  MuiAutocomplete: {
		styleOverrides: {
		  root: {
			'& label.Mui-focused': {
			  color: '#0086c8',
			},
			'& .MuiInput-underline:after': {
			  borderBottomColor: '#0086c8',
			},
			'& .MuiOutlinedInput-root': {
			  '&:hover fieldset': {
				borderColor: '#0086c8',
			  },
			  '&.Mui-focused fieldset': {
				borderColor: '#0086c8',
			  },
			},
		  },
		},
	  },
	  MuiTableCell: {
		styleOverrides: {
		  root: {
			fontSize: '16px',
			'& .MuiBox-root': {
			  fontSize: '16px',
			},
		  },
		},
	  },
	  MuiTableRow: {
		styleOverrides: {
		  root: {
			fontSize: '16px',
		  },
		},
	  },
	  MuiButton: {
		styleOverrides: {
		  root: {
			fontSize: '16px',
		  },
		},
	  },
	},
  });
  
  

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<BrowserRouter basename="">
		<RecoilRoot>
			<LanguageProvider>
				<ThemeProvider theme={theme}>
					<App />
				</ThemeProvider>
			</LanguageProvider>
		</RecoilRoot>
	</BrowserRouter>
);

/*

	   </LanguageProvider>
*/